import React, {Fragment} from 'react';

import {
    SimpleForm,
    Edit,
    Create,
    TextInput,
    TextField,
    SelectInput,
    SaveButton,
    Toolbar,
    required,
    maxLength
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import Avatar from "@material-ui/core/Avatar";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import DomainIcon from '@material-ui/icons/Domain';
import SitesStore from "../stores/SitesStore";
import simpleMemoize from "../../framework/util/forms/SimpleMemoize";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const abbrevUnique = simpleMemoize(async value => {
    if (!value) {
        return "Required";
    }
    try {
        const existing = await new SitesStore().findById(value);
        if (existing) {
            return "Already taken!";
        }
    }
    catch(error) {
        // Ignore
    }
});

const siteNameUnique = simpleMemoize(async value => {
    if (!value) {
        return "Required";
    }
    const data = await new SitesStore().findAll();
    const list = data.data;
    console.log('Checking site name is unique', {list})
    var taken = false;
    for(let i = 0; i < list.length; i++){
        const site = list[i];
        console.log('Checking site', {site});
        if (site.name === value) {
            taken = true;
            console.log('Site name is already taken: ', {value, site});
        }

    }
    if (taken)
        return "Already taken!";


});




const validateAbbrev = [required(), maxLength(10), abbrevUnique];

const AbbervInput = (props) => {
    return (
        <TextInput
            label="Site Id Abbreviation"
            source="id"
            variant='outlined'
            helperText={'An unique abbreviation for the site, typically around 4 characters.'}
            validate={validateAbbrev}
        >
        </TextInput>);
}

const AbbervField = (props) => {
    return (
        <TextInput
            label="Site Id Abbreviation"
            source="id"
            variant='outlined'
            helperText={'An unique abbreviation for the site, typically around 4 characters.'}
            disabled

        >
        </TextInput>);
}


const NameInput = (props) => {
    return (
        <TextInput
            label="Name"
            source="name"
            variant='outlined'
            validate={[required(), siteNameUnique]}
            helperText={'A unique name for this site, often a city name.'}
        >
        </TextInput>);
}

const Street1Input = (props) => {
    return (
        <TextInput
            label="Street1"
            source="street1"
            variant='outlined'
            validate={required()}
        >
        </TextInput>);
}

const Street2Input = (props) => {
    return (
        <TextInput
            label="Street2"
            source="street2"
            variant='outlined'
        >
        </TextInput>);
}

const CityInput = (props) => {
    return (
        <TextInput
            label="City"
            source="city"
            variant='outlined'
            validate={required()}
        >
        </TextInput>);
}

const zipValidation = (value, allValues) => {

    var isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
    if (!isValidZip)
        return 'Invalid Zip';
    else
        return undefined;
}

const validateZip = [required(), zipValidation];

const ZipInput = (props) => {
    return (
        <TextInput
            label="Zip"
            source="zip"
            variant='outlined'
            validate={validateZip}
        >
        </TextInput>);
}


const StateInput = (props) => {
    return (
        <SelectInput source="state" required choices={[
            { id: 'AL', name: 'Alabama' },
            { id: 'AK', name: 'Alaska' },
            { id: 'AZ', name: 'Arizona' },
            { id: 'AR', name: 'Arkansas' },
            { id: 'CA', name: 'California' },
            { id: 'CO', name: 'Colorado' },
            { id: 'CT', name: 'Connecticut' },
            { id: 'DE', name: 'Delaware' },
            { id: 'DC', name: 'District Of Columbia' },
            { id: 'FL', name: 'Florida' },
            { id: 'GA', name: 'Georgia' },
            { id: 'HI', name: 'Hawaii' },
            { id: 'ID', name: 'Idaho' },
            { id: 'IL', name: 'Illinois' },
            { id: 'IN', name: 'Indiana' },
            { id: 'IA', name: 'Iowa' },
            { id: 'KS', name: 'Kansas' },
            { id: 'KY', name: 'Kentucky' },
            { id: 'LA', name: 'Louisiana' },
            { id: 'ME', name: 'Maine' },
            { id: 'MD', name: 'Maryland' },
            { id: 'MA', name: 'Massachusetts' },
            { id: 'MI', name: 'Michigan' },
            { id: 'MN', name: 'Minnesota' },
            { id: 'MS', name: 'Mississippi' },
            { id: 'MO', name: 'Missouri' },
            { id: 'MT', name: 'Montana' },
            { id: 'NE', name: 'Nebraska' },
            { id: 'NV', name: 'Nevada' },
            { id: 'NH', name: 'New Hampshire' },
            { id: 'NJ', name: 'New Jersey' },
            { id: 'NM', name: 'New Mexico' },
            { id: 'NY', name: 'New York' },
            { id: 'NC', name: 'North Carolina' },
            { id: 'ND', name: 'North Dakota' },
            { id: 'OH', name: 'Ohio' },
            { id: 'OK', name: 'Oklahoma' },
            { id: 'OR', name: 'Oregon' },
            { id: 'PA', name: 'Pennsylvania' },
            { id: 'RI', name: 'Rhode Island' },
            { id: 'SC', name: 'South Carolina' },
            { id: 'SD', name: 'South Dakota' },
            { id: 'TN', name: 'Tennessee' },
            { id: 'TX', name: 'Texas' },
            { id: 'UT', name: 'Utah' },
            { id: 'VT', name: 'Vermont' },
            { id: 'VA', name: 'Virginia' },
            { id: 'WA', name: 'Washington' },
            { id: 'WV', name: 'West Virginia' },
            { id: 'WI', name: 'Wisconsin' },
            { id: 'WY', name: 'Wyoming' },
        ]} />
    );
}


const Header = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.paper}>
            <Avatar className={classes.avatar}>
                <DomainIcon/>
            </Avatar>
            <Typography component="h1" variant="h5">
                Site Setup
            </Typography>
            <br/>
            <Typography component="h5">
                Configure site related settings.  Site settings are used for data analysis.
            </Typography>
        </div>
    );
}


const FormContentsCreate = (props) => {
    return (
        <SimpleForm {...props}  redirect="list">
            <AbbervInput/>
            <NameInput />
            <Street1Input/>
            <Street2Input/>
            <CityInput/>
            <StateInput/>
            <ZipInput/>
            <RichTextInput source="notes" label={'Additional Notes'}/>
        </SimpleForm>
    );
}

const FormContentsEdit = (props) => {
    return (
        <SimpleForm {...props}  redirect="list">
            <AbbervField/>
            <NameInput />
            <Street1Input/>
            <Street2Input/>
            <CityInput/>
            <StateInput/>
            <ZipInput/>
            <RichTextInput source="notes" label={'Additional Notes'}/>
        </SimpleForm>
    );
}




export const SiteEditCommon = ({record, ...props}) => {
    const classes = useStyles();
    return (
        <div>
            <Header></Header>
            <Edit {...props} >
                <FormContentsEdit {...props}/>
            </Edit>

        </div>
    );
}

export const SiteCreateCommon = (props) => {
    const classes = useStyles();
    return (
        <div>
            <Header></Header>
            <Create {...props} >
                <FormContentsCreate {...props}/>
            </Create>

        </div>
    );
}
